import { render, staticRenderFns } from "./dggj-header.vue?vue&type=template&id=1888127c&scoped=true"
import script from "./dggj-header.vue?vue&type=script&lang=js"
export * from "./dggj-header.vue?vue&type=script&lang=js"
import style0 from "./dggj-header.vue?vue&type=style&index=0&id=1888127c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1888127c",
  null
  
)

export default component.exports